import query from './query';
import { COLUMNS } from './keys';
import CheckData from '../../../components/CatchError';
import DataTable from '../../../components/Datatable';
import LoadMoreComponent from '../../../components/LoadMoreComponent';
import { getPercent } from '../../../helpers/showDelta';
import ManualClusterSelect from '../../../components/manualClusterModal';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class GSCReportUrlDetailTable extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({
            offset: 0,
            current_url: props.url,
            last_week: props.last_week,
            prior_week: props.prior_week,
        });
        this.offsetStep = 1000;

        this.onSelect = this.onSelect.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.keyword?.toLowerCase().includes(search.toLowerCase()));
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    render() {
        const { t } = this.props;

        const attr = {
            query,
            offsetStep: this.offsetStep,
            current_url: this.props.url,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
        };

        const sortFns = {
            keyword: (array) => array.sort((a, b) => a.keyword.localeCompare(b.keyword)),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.clicks, a.clicksPrior) - getPercent(b.clicks, b.clicksPrior),
                ),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.impressions, a.impressionsPrior) -
                        getPercent(b.impressions, b.impressionsPrior),
                ),
            position: (array) => array.sort((a, b) => a.position - b.position),
            position_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.position, a.positionPrior) -
                        getPercent(b.position, b.positionPrior),
                ),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
            ctr_delta: (array) =>
                array.sort((a, b) => getPercent(a.ctr, a.ctrPrior) - getPercent(b.ctr, b.ctrPrior)),
        };

        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const extraBtns = () => (
            <div className="table-additional-view justify-content-end">
                <div className="table-additional-view-btns justify-content-end">
                    <ManualClusterSelect
                        current_url={this.props.current_url}
                        csrf_token={this.props.csrf_token}
                        selectedItems={this.state.selectedItems?.map((id) => ({
                            id,
                            keyword: this.state.allData.find((item) => item.id === id).keyword,
                        }))}
                        header={t('search.urls_details.table.clusters_name')}
                        cluster_type="keyword"
                        onRemoveAllSelected={this.onRemoveAllSelected}
                    />
                </div>
            </div>
        );

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.allData}
                    loading={this.state.loading}
                    loadMore={this.state.loadMore}
                >
                    <DataTable
                        nodes={this.state.allData}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS(t)}
                        fileName={t('search.urls_details.table.header')}
                        header={t('search.urls_details.table.header')}
                        defaultSortKey="clicks"
                        additionalBox={extraBtns}
                        searchFunction={this.searchFunction}
                        removeAllSelected={this.state.removeAllSelected}
                        hasSelect={true}
                        forceRun={this.forceRun}
                        onSelect={this.onSelect}
                        showLoadMoreBtn={showLoadMoreBtn}
                        loadMoreLoading={this.state.loadMore}
                        loadMore={() => this.loadMore(attr)}
                        additionalStyles={{
                            Table: `
                                    --data-table-library_grid-template-columns :minmax(60px, 0.5fr) minmax(200px, 2fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) !important;
                                   ${scrollForTable}
                                `,
                            BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default withTranslation()(GSCReportUrlDetailTable);
